module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/absolvierendenhut-78599da34dfef5f12a62679134e075b2.svg";